const envs = {
    dev: {
        baseOrderUrl: "https://api.dev.servd.uk",
        mockClients: false,
        whitelabelUrl: "https://events.dev.servd.uk/"
    },
    prod: {
        baseOrderUrl: "https://api.prod.servd.uk",
        mockClients: false,
        whitelabelUrl: "https://events.servd.uk/"
    },
    local: {
        baseOrderUrl: process.env.REACT_APP_BASE_ORDER_URL,
        mockClients: process.env.REACT_APP_MOCK_CLIENTS,
        whitelabelUrl: "https://events.dev.servd.uk/"
    },
}

let config
const stage = process.env.REACT_APP_STAGE

if (stage && envs.hasOwnProperty(stage)) {
    config = envs[stage]
} else {
    config = envs.local
}


export default config;